<template>
    <div class="column py-3" style="height: 100vh; overflow-y: auto">
        <div v-if="showUI">
            <div class="text-xs-center py-3 font-bold" style="margin-top: 48px">
                Hướng dẫn hành khách quét camera vào mã QR
            </div>
            <div class="row justify-center pt-2">
                <div>
                    <div
                        class="pa-2 row justify-center align-center shadow"
                        style="
                            border-radius: 7px;
                            width: 270px;
                            height: 270px;
                            position: relative;
                        "
                    >
                        <div
                            v-if="hetThoiGianThanhToan"
                            style="
                                position: absolute;
                                top: 40%;
                                left: 23%;
                                font-size: 16px;
                                z-index: 8;
                            "
                        >
                            <div class="column justify-center">
                                Hết thời gian thanh toán
                                <ion-button
                                    color="primary"
                                    style="margin: 0 auto"
                                    class="mt-2"
                                    expand="block"
                                    @click="thucHienThanhToan()"
                                >
                                    Tạo lại mã
                                </ion-button>
                            </div>
                        </div>
                        <div
                            :style="hetThoiGianThanhToan ? 'opacity:0.1' : ''"
                            class="full-width full-height"
                        >
                            <QrCodeVue
                                v-if="ThongTinQrCode.qrCode"
                                :data="ThongTinQrCode.qrCode"
                                style="background-color: white"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div style="text-align: center" :class="`pt-3 pb-2 ${color}--text font-14`">
                <span class="font-weight-regular">Thời gian thanh toán:</span>
                <span
                    class="font-weight-regular font-20 pl-4"
                    :class="
                        'color: ' +
                        (timeOut < 60000
                            ? 'color-error'
                            : timeOut < 120000
                            ? 'color-warning'
                            : 'color-success')
                    "
                    style="font-weight: 500"
                >
                    {{ `\xa0` + getTimeMinutes(timeOut) }}s
                </span>
            </div>
            <div
                class="row align-center justify-space-around font-16 font-bold"
                style="width: 80%; margin: 0px auto !important"
                py-3
            >
                <div class="pr-2">Số tiền thanh toán:</div>
                <div class="font-20 color-success">
                    {{ $MoneyFormat(ThongTinQrCode.tongTienThanhToan) }}đ
                </div>
            </div>
            <div class="py-4 mb-4">
                <div class="container-md boundary">
                    <div class="font-14 font-bold text-xs-center">
                        Thông tin người nhận
                    </div>
                    <div class="font-12">
                        <div class="row pt-2">
                            <div class="font-bold xs5" style="min-width: 58px">
                                Người nhận:
                            </div>
                            <div class="xs7">
                                {{ ThongTinTaiKhoanThanhToan.NguoiNhan }}
                            </div>
                        </div>
                        <div class="row pt-2">
                            <div class="font-bold xs5" style="min-width: 58px">
                                Số tài khoản nhận:
                            </div>
                            <div class="xs7">
                                {{ ThongTinTaiKhoanThanhToan.SoTaiKhoan }}
                            </div>
                        </div>
                        <div class="row pt-2">
                            <div class="font-bold xs5" style="min-width: 58px">
                                Số điện thoại:
                            </div>
                            <div class="xs7">
                                {{ ThongTinTaiKhoanThanhToan.SoDienThoai }}
                            </div>
                        </div>
                        <div class="row pt-2">
                            <div class="font-bold xs5" style="min-width: 58px">
                                Ngân hàng:
                            </div>
                            <div class="xs7">
                                {{ ThongTinTaiKhoanThanhToan.NganHang }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="row mt-3 justify-end"
                style="
                    position: fixed;
                    bottom: 0;
                    border-top: 1px solid #dadce0;
                    left: 0;
                    padding: 12px;
                    background-color: #fff;
                    z-index: 9;
                "
            >
                <DxButton
                    text="HỦY THANH TOÁN"
                    type="danger"
                    styling-mode="contained"
                    style="width: 100%"
                    @click="HuyThanhToan()"
                />
            </div>
        </div>
    </div>
</template>
<script>
import { IonButton } from "@ionic/vue";
import { DxButton } from "devextreme-vue";
import QrCodeVue from "../../../components/QrCode.vue";
var timeOutFunc;
export default {
    components: {
        IonButton,
        DxButton,
        QrCodeVue,
    },
    props: {
        ThongTinThanhToanQrCode: { type: Object, default: {} },
    },
    data() {
        return {
            ThongTinTaiKhoanThanhToan: {
                NguoiNhan: null,
                SoTaiKhoan: null,
                SoDienThoai: null,
                NganHang: null,
            },
            ThongTinQrCode: {
                QrCode: null,
            },
            timeOut: 0,
            showUI: false,
        };
    },
    methods: {
        DongPopup() {
            this.$emit("hiddenPopup", "PopupThanhToanQrCode");
        },
        HuyThanhToan() {
            if (this.ThongTinQrCode.maGiaoDich) {
                this.XacNhanHuyThanhToan();
            } else {
                this.DongPopup();
            }
        },
        async XacNhanHuyThanhToan() {
            try {
                this.$startLoading;
                let rs = await this.$store.dispatch(
                    "NhanVienBanVe/HuyThanhToanQr",
                    this.ThongTinQrCode.maGiaoDich,
                );

                if (rs.status) {
                    this.$Helper.ThongBaoToast(
                        "success",
                        "Hủy thanh toán QR thành công!",
                    );
                    clearInterval(timeOutFunc);
                    this.DongPopup();
                } else {
                    if (rs.errorCode == 9000) {
                        this.KeyError = "HuyThanhToan";
                        this.$Helper.ThongBaoPopup({
                            type: "Error",
                            message_title:
                                "Hủy thanh toán QR thất bại. Đã nhận được tiền chuyển khoản!",
                            message: "Đơn hàng đã được thanh toán thành công!",
                            textButton: "Tiếp tục",
                        });
                    } else {
                        this.$Helper.ThongBaoPopup({
                            type: "Error",
                            message_title: "Hủy thanh toán QR thất bại!",
                            message: rs.message,
                        });
                    }
                }
            } catch (error) {
                console.log("🚀 ~ error", error);
            } finally {
                this.$stopLoading;
            }
        },
        async LayThongTinThanhToan() {
            try {
                this.$startLoading;
                let resp = await this.$store.dispatch(
                    "NhanVienBanVe/ThanhToanBangBangViDienTu",
                    this.ThongTinThanhToanQrCode,
                );
                if (!resp.status) {
                    this.$Helper.ThongBaoPopup({
                        type: "Error",
                        message_title: "Không tìm thấy thông tin thanh toán!!",
                        message: resp.message,
                        textButton: "Tiếp tục",
                    });
                } else {
                    this.TrangThaiThanhToan = false;
                    this.ThongTinQrCode.maGiaoDich = resp.data.maGiaoDich;
                    this.ThongTinQrCode.qrCode = resp.data.qrCode;
                    this.ThongTinQrCode.thoiGianHetHanThanhToan =
                        resp.data.thoiGianHetHanThanhToan;
                    this.ThongTinQrCode.thoiGianHienTai = resp.data.thoiGianHienTai;
                    this.ThongTinQrCode.tongTienThanhToan = resp.data.tongTienThanhToan;
                    this.KhoiTaoQrThanhToan();
                }
            } catch (error) {
                console.log("🚀 ~ LayThongTinThanhToan ~ error:", error);
            } finally {
                this.$stopLoading;
            }
        },
        KhoiTaoQrThanhToan() {
            clearInterval(timeOutFunc);

            this.timeOut =
                Math.floor(
                    (new Date(this.ThongTinQrCode.thoiGianHetHanThanhToan).getTime() -
                        new Date(this.ThongTinQrCode.thoiGianHienTai).getTime()) /
                        1000,
                ) * 1000;

            timeOutFunc = setInterval(() => {
                this.timeOut -= 1000;
                if (this.timeOut == 0) {
                    clearInterval(timeOutFunc);
                    this.XacNhanHuyThanhToan();
                }

                if (this.timeOut % 2000 == 0) {
                    this.checkPay();
                }
            }, 1000);
        },
        async checkPay() {
            try {
                let rs = await this.$store.dispatch(
                    "NhanVienBanVe/KiemTraThanhToan",
                    this.ThongTinQrCode.maGiaoDich,
                );
                if (rs.data == true && rs.errorCode == 0) {
                    this.$Helper.ThongBaoToast("success", "Thanh toán thành công!");
                    clearInterval(timeOutFunc);
                    this.$emit("ThanhToanQrThanhCong", {
                        ...this.ThongTinThanhToanQrCode,
                        ...this.ThongTinQrCode,
                    });
                    this.DongPopup();
                }
            } catch (ex) {
                this.$Helper.ThongBaoToast(
                    "error",
                    "Kiểm tra thanh toán gặp lỗi! Lỗi hệ thống.",
                );
                console.log("🚀 ~", ex);
            }
        },
        getTimeMinutes(s) {
            if (s > 0) {
                let time = s / 1000;
                let minute = Math.floor(time / 60);
                let second = time - 60 * minute;
                let rsMinute = minute < 10 ? "0" + minute : minute;
                let rsSecond = second < 10 ? "0" + second : second;
                return rsMinute + ":" + rsSecond;
            }
            return "00:00";
        },
        LayThongTinVe() {},
        async LayThongTinTaiKhoanThanhToan() {
            try {
                let rs = await this.$store.dispatch(
                    "NhanVienBanVe/LayThongTinTaiKhoanThanhToan",
                );
                if (!rs.status) {
                    this.$Helper.ThongBaoToast(
                        "error",
                        "Không tìm thấy thông tin người nhận! " + rs.message,
                    );
                } else {
                    this.ThongTinTaiKhoanThanhToan.NguoiNhan = rs.data.nguoiNhan;
                    this.ThongTinTaiKhoanThanhToan.SoTaiKhoan = rs.data.taiKhoan;
                    this.ThongTinTaiKhoanThanhToan.SoDienThoai = rs.data.soDienThoai;
                    this.ThongTinTaiKhoanThanhToan.NganHang = rs.data.tenNganHang;
                }
            } catch (error) {
                console.log("🚀 ~ LayThongTinTaiKhoanThanhToan ~ error:", error);
            }
        },
    },
    async created() {
        await this.LayThongTinThanhToan();
        await this.LayThongTinTaiKhoanThanhToan();

        setTimeout(() => {
            this.showUI = true;
        }, 100);
    },
    mounted() {},
};
</script>
<style scoped></style>
